import { useEffect, useRef } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { formatCurrency } from '../HiveFundInvestFlow.utils';

interface WelcomeStepProps {
  onContinue: () => void;
  minInvestment: number;
}

export function WelcomeStep({ onContinue, minInvestment }: WelcomeStepProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="space-y-8 text-center">
      <div>
        <h1
          ref={headingRef}
          tabIndex={-1}
          className="text-3xl md:text-4xl mb-2 focus-visible:outline-none"
          >
          Invest in The Hive Fund
        </h1>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Join thousands of investors earning passive income through diversified real estate.
        </p>
      </div>

      <div className="rounded-xl border-2 border-border bg-card p-8 text-left">
        <h3 className="text-lg font-medium mb-4">What you'll need:</h3>
        <ul className="space-y-3">
          <li className="flex items-center gap-3 text-muted-foreground">
            <CheckCircle2 className="w-5 h-5 text-muted-foreground flex-shrink-0" />
            <span>Verified account with completed KYC</span>
          </li>
          <li className="flex items-center gap-3 text-muted-foreground">
            <CheckCircle2 className="w-5 h-5 text-muted-foreground flex-shrink-0" />
            <span>Minimum investment of {formatCurrency(minInvestment)}</span>
          </li>
          <li className="flex items-center gap-3 text-muted-foreground">
            <CheckCircle2 className="w-5 h-5 text-muted-foreground flex-shrink-0" />
            <span>Bank account or crypto wallet for payment</span>
          </li>
        </ul>
      </div>

      <Button className="w-full h-14 text-lg" onClick={onContinue}>
        Get Started
      </Button>
    </div>
  );
}
